import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from "@angular/router";
import { ValidationService } from '../../../app/validation.service';
import { AuthenticationServiceService } from '../../../app/authentication-service.service';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { ChangeUsersService } from '../../../app/services/change-users.service';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  Validators,
} from "@angular/forms";
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  public service:BackendApiService =inject(BackendApiService);
  public changeUserDashboard: ChangeUsersService = inject(ChangeUsersService);
  private authenticationService: AuthenticationServiceService = inject(AuthenticationServiceService);
  public loginWithOtpUrl = BaseUrlConstantsService.LOGIN;
  public CGkey = BaseUrlConstantsService.CG_KEY;
  private confirmOtpUrl = BaseUrlConstantsService.LOGINWITHOTP;
  private clientSubscriptionURL = BaseUrlConstantsService.CLIENTS_SUBSCRIPTIONS_URL;
  private otpRequest = BaseUrlConstantsService.SEND_OTP;
  public hasErrors: Boolean = false;
  public errorMessage = "";
  public loginErrorCode = "";
  public loginErrorMessage = "";
  public username = "";
  public password = "";
  public userForm: any;
  public role: any;
  public pageRef: any;
  public returnUrl!: string;
  public email!: string;
  public customer: any;
  public color = "accent";
  public checked = false;
  public disabled = false;
  public otpDiv = false;
  public passwordDiv = true;
  public passwordlable!: string;
  public customer_Img!: string;
  public custom_error_msg = "";
  public loaderImg = false;
  public loaderOtp = false;
  private token: any;
  public usernameSelector!: boolean;
  /*
    - Declares all Required Services as Class's Properties
    - Commented by Sarthak on Feb 12, 2024

  */
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder
  ) {}

  /*
    - Changes Login type from Password to OTP or OTP to Password
    - Commented by Sarthak on Feb 12, 2024
  */
  onChange(value :any) {
    if (value.currentTarget.checked === true) {
      this.passwordlable = "OTP";
      this.otpDiv = true;
      this.passwordDiv = false;
      this.userForm = this.formBuilder.group({
        email: ["", [Validators.required]],
        otp: ["", Validators.required],
      });
    } else {
      this.passwordlable = "Password";
      this.passwordDiv = true;
      this.otpDiv = false;
      this.userForm = this.formBuilder.group({
        email: ["", [Validators.required, ValidationService.emailValidator]],
        password: [
          "",
          [Validators.required, ValidationService.passwordValidator],
        ],
      });
    }
  }
  /*
      - Sends login Request and on success saves the user info like  userid,name,country as well as Authorization Token to LocalStorage
      - then depending upon role of the User ,is he Admin Client User or AccountManager we navigate  to one of these -> device-reports , admin-dashboard ,etc
      - Commented by Sarthak on Feb 12, 2024
  */
  public saveUser(): void {
    var body;
    if (this.passwordDiv === true) {
      if (this.usernameSelector == true) {
        body = {
          username: this.userForm.value.email.toLowerCase(),
          password: this.userForm.value.password,
        };
      } else {
        body = {
          email: this.userForm.value.email.toLowerCase(),
          password: this.userForm.value.password,
        };
      }
      this.changeUserDashboard.loader(true);
      this.loaderImg = true;
      this.service
        .postDataSigin(this.loginWithOtpUrl, body)
        .then((response) => {
          // this.changeUserDashboard.autoCheckout();
          this.loaderImg = false;
          this.changeUserDashboard.loader(false);
          var rsStatus = JSON.parse(JSON.stringify(response)).data.status;
          if (rsStatus === "success") {
            this.authenticationService.login(this.userForm.value);
            localStorage.setItem("loginStatus", "yes");
            localStorage.setItem("admin_client_id", 'null');
            let userName = JSON.parse(JSON.stringify(response)).data.body.user
              .full_name;
            let _compnyName = JSON.parse(JSON.stringify(response)).data.body
              .user.company_name;
            let countryName = JSON.parse(JSON.stringify(response)).data.body
              .user.country;
            let userID = JSON.parse(JSON.stringify(response)).data.body.user.id;
            this.role = JSON.parse(
              JSON.stringify(response)
            ).data.body.user.role;
            // console.log(this.role, "role");
            this.customer = JSON.parse(
              JSON.stringify(response)
            ).data.body.user.role;
            this.email = JSON.parse(
              JSON.stringify(response)
            ).data.body.user.email.toLowerCase();
            this.customer_Img = JSON.parse(
              JSON.stringify(response)
            ).data.body.user.profile_image;
            this.token = JSON.parse(JSON.stringify(response)).data.body.token;
            localStorage.setItem(
              "associated_clientid",
              JSON.parse(JSON.stringify(response)).data.body.user
                .associated_clientid
            );
            localStorage.setItem("token", this.token);
            localStorage.setItem("country", countryName);
            localStorage.setItem("admin_client_name", "");
            localStorage.setItem(
              "clientTimeZone",
              JSON.parse(JSON.stringify(response)).data.body.user.timezone
            );
            localStorage.setItem("user_id", userID.toString());
            // console.log(localStorage.getItem("user_id"));
            localStorage.setItem("customerName", this.customer);
            localStorage.setItem("userEmail", this.email);
            localStorage.setItem("role", this.role);
            localStorage.setItem("user_name", userName);
            localStorage.setItem("company_name", _compnyName);
            localStorage.setItem("user_img", this.customer_Img);
            localStorage.setItem(
              "client_id",
              JSON.parse(JSON.stringify(response)).data.body.user.client_id
            );

              const checkSubscriptionResponse: any = this.service.postData(this.clientSubscriptionURL, { clientId: userID, role: this.role });
              console.log(checkSubscriptionResponse, "checkSubscriptionResponse");
            this.service.updateTokenOnLogin();

              // console.log(localStorage.getItem("token"));
              this.changeUserDashboard.login("Log In");
              switch (this.role) {
                case "CLIENT":
                  this.service.showSuccess("You are successfully logged in");
                  this.router.navigate(["/device-reports"]);
                  break;
                case "ADMIN":
                  this.service.showSuccess("You are successfully logged in");
                  this.router.navigate(["/admin-dashboard"]);
                  // console.log("routing done ")
                  break;
                case "USER":
                  this.service.showSuccess("You are successfully logged in");
                  this.router.navigate(["/device-reports"]);
                  break;
                case "ACCOUNT_MANAGER":
                  this.service.showSuccess("You are successfully logged in");
                  this.router.navigate(["/manager-client-list"]);
                  break;
                case "OEM":
                  this.service.showSuccess("You are successfully logged in");
                  this.router.navigate(["/OEM-Client"]);
                  break;
              }


          } else if (rsStatus === "fail") {
            this.service.showError("Incorrect username or password");
          } else {
            this.service.showError("Something went wrong.");
          }
        });
    } else {
      body = {
        email: this.userForm.value.email.toLowerCase(),
        otp: this.userForm.value.otp,
      };
      this.loaderImg = true;
      this.changeUserDashboard.loader(true);
      this.service.postDataSigin(this.confirmOtpUrl, body).then((response) => {
        // this.changeUserDashboard.autoCheckout();
        this.loaderImg = false;
        this.changeUserDashboard.loader(false);
        var rsStatus = JSON.parse(JSON.stringify(response)).data.status;
        if (rsStatus === "success") {
          this.authenticationService.login(this.userForm.value);
          localStorage.setItem("loginStatus", "yes");
          let _compnyName = JSON.parse(JSON.stringify(response)).data.body.user
            .company_name;
          let countryName = JSON.parse(JSON.stringify(response)).data.body.user
            .country;
          let userName = JSON.parse(JSON.stringify(response)).data.body.user
            .full_name;
          let userID = JSON.parse(JSON.stringify(response)).data.body.user.id;
          this.role = JSON.parse(JSON.stringify(response)).data.body.user.role;
          this.customer = JSON.parse(
            JSON.stringify(response)
          ).data.body.user.role;
          this.email = JSON.parse(
            JSON.stringify(response)
          ).data.body.user.email.toLowerCase();
          this.customer_Img = JSON.parse(
            JSON.stringify(response)
          ).data.body.user.profile_image;
          localStorage.setItem("admin_client_name", "");
          localStorage.setItem(
            "associated_clientid",
            JSON.parse(JSON.stringify(response)).data.body.user
              .associated_clientid
          );
          this.token = JSON.parse(JSON.stringify(response)).data.body.token;
          localStorage.setItem("admin_client_id", 'null');
          localStorage.setItem("token", this.token);
          localStorage.setItem("country", countryName);
          localStorage.setItem(
            "clientTimeZone",
            JSON.parse(JSON.stringify(response)).data.body.user.timezone
          );
          localStorage.setItem("customerName", this.customer);
          localStorage.setItem("userEmail", this.email);
          localStorage.setItem("role", this.role);
          localStorage.setItem("user_name", userName);
          localStorage.setItem("company_name", _compnyName);
          localStorage.setItem("user_id", userID.toString());
          localStorage.setItem("user_img", this.customer_Img);
          localStorage.setItem(
            "client_id",
            JSON.parse(JSON.stringify(response)).data.body.user.client_id
          );

          this.changeUserDashboard.login("Log In");
          switch (this.role) {
            case "CLIENT":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/device-reports"]);

              break;
            case "ADMIN":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/admin-dashboard"]);
              break;
            case "USER":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/device-reports"]);
              break;
            case "ACCOUNT_MANAGER":
              this.service.showSuccess("You are successfully logged in");
              this.router.navigate(["/manager-client-list"]);
              break;
            case "OEM":
              this.service.showSuccess("You are successfullyyyyy logged in.");
              this.router.navigate(["/OEM-Client"]);
          }
        } else if (rsStatus === "fail") {
          this.service.showError("Incorrect username or password");
        } else {
          this.service.showError("Something went wrong.");
        }
      });
    }
  }
  /*
      - Tries to get saved user info from localstorage
      - if found redirects to role specific page  else redirects to login Page
      - Also creates form object
      - Commented by Sarthak on Feb 12, 2024
  */
  ngOnInit() {
    this.userForm = this.formBuilder.group({
      email: ["", [Validators.required, ValidationService.emailValidator]],
      password: [
        "",
        [Validators.required, ValidationService.passwordValidator],
      ],
    });
    if (localStorage.getItem("loginStatus") === "yes") {
      switch (localStorage.getItem("role")) {
        case "ADMIN":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/admin-dashboard"]);
          break;
        case "CLIENT":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/device-reports"]);
          break;
        case "USER":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/device-reports"]);
          break;
        case "ACCOUNT_MANAGER":
          this.changeUserDashboard.login("Log In");
          this.router.navigate(["/manager-client-list"]);
          break;
      }
    } else {
      this.changeUserDashboard.logout();
    }
  }
  /*
      - Checks if email is valid and sets email field
      - If email is invalid them assume email as a Username
      - Commented by Sarthak on Feb 12, 2024
  */
  getInputValue(value: string) {
    if (this.emailValid(value)) {
      this.usernameSelector = true;
    } else {
      this.usernameSelector = false;
    }
  }
  /* Function to Check Valid Email
      - This function is designed to validate an email address using a regular expression pattern
      - Commented by Sarthak on Feb 12, 2024
  */
  emailValid(control :any) {
    // RFC 2822 compliant regex
    if (
      control.match(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
    ) {
      return false;
    } else {
      return true;
    }
  }
  /* Function To Send OTP
      - Tries to send OTP to email mentioned and renders the Success or Error Message
      - Commented by Sarthak on Feb 12, 2024
  */
  async sendOtp() {
    if (this.userForm.value.email.toLowerCase() === "") {
      this.custom_error_msg = "Email address can't be empty.";
      this.service.showError(this.custom_error_msg);
    } else {
      const body = {
        email: this.userForm.value.email.toLowerCase(),
      };
      this.changeUserDashboard.loader(true);
      this.loaderOtp = true;
      this.service.postDataSigin(this.otpRequest, body).then((response) => {
        this.changeUserDashboard.loader(false);
        this.loaderOtp = false;
        var rsStatus = JSON.parse(JSON.stringify(response)).response;
        if (rsStatus.includes("OK")) {
          this.service.showSuccess(
            "An email has been sent on your mail address, Please check."
          );
        } else {
          this.service.showError("error while sending otp");
        }
      });
    }
  }
  /*    Navigate To SignUp Page
      - Commented by Sarthak on Feb 12, 2024
  */
  async signupScreen() {
    this.router.navigate(["/auth/register"]);
  }
  /* Navigate To forgot-password Page
     - Link :: https://dev.enertics.ca/#/forgot-password
     - Commented by Sarthak on Feb 12, 2024
  */
  async goToForgotPassword() {
    this.router.navigate(["forgot-password"]);
  }
}
